import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CoreCOMService } from "../../services/com.service";
import { ClientType } from "../../services/com/comEnvironmentClient";
import { env } from "../../../../environments/environment";
import { IRemoteOrderGroupShareService } from "./remoteOrderGroupShare.facade";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";

@Injectable()
export class RemoteOrderGroupShareService implements IRemoteOrderGroupShareService, OnDestroy {

  public groupLink: string;

  constructor(private _remoteGroupOrderService: RemoteGroupOrderService,
    private _coreCOMService: CoreCOMService,
  ) {
    const me = this;

    me.groupLink = me.createGroupLink();
    me.checkGroupFullStatus();
  }

  ngOnDestroy(): void {
    // Cleanup if required
    const me = this;
  }

  /** Checks and updates the status whether the group is full.*/
  private async checkGroupFullStatus(): Promise<void> {
    const me = this;
    const groupIsFull = await me._remoteGroupOrderService.checkGroupFullStatus();
    me._setGroupIsFull(groupIsFull);
  }

  /** Updates status whether the group is full */
  private _setGroupIsFull(value: boolean): void {
    const me = this;
    if (me._groupIsFull != value) {
      me._groupIsFull = value;
      me._groupIsFullSubject.next(value);
    }
  }

  /** Group is full state */
  private _groupIsFull: boolean = false;
  private _groupIsFullSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  get groupIsFull$(): Observable<boolean> {
    return this._groupIsFullSubject.asObservable();
  }

  /**
 * Creates a group link based on the current environment and group code.
 * @returns {string} The constructed group link.
 */
  private createGroupLink(): string {
    const origin = this.determineOrigin();
    const site = "PreOrder/";
    const groupcode = this._remoteGroupOrderService.groupId;
    return `${origin}${site}${groupcode}`;
  }

  /**
 * Determines the origin URI based on the client type.
 * @returns {string} The origin URI.
 */
  private determineOrigin() {
    return env.YourAppServer.BaseURI;
    // switch (this._coreCOMService.environment.client.type) {
    //   case ClientType.ios:
    //   case ClientType.android:
    //     return env.YourAppServer.BaseURI;
    //   default:
    //     return location.origin + "/";
    // }
  }
}
